export const TITLE = 'arrangement_group.title';
